import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex gap-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user-plus fa-sm" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-plus fa-sm" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-box-archive" }, null, -1)
const _hoisted_5 = { class: "cell-item" }
const _hoisted_6 = { class: "cell-item" }
const _hoisted_7 = { class: "cell-item" }
const _hoisted_8 = { class: "cell-item" }
const _hoisted_9 = { class: "cell-item" }
const _hoisted_10 = { class: "cell-item" }
const _hoisted_11 = { class: "demo-collapse mt-5" }
const _hoisted_12 = { class: "fs-5 fw-bold" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "text-gray-700"
}
const _hoisted_15 = { class: "fs-6 fw-bold" }

import SimpleForm from "@/components/SimpleForm.vue";
import { computed, inject, ref } from "vue";
import {
  Iphone,
  Message,
  OfficeBuilding,
  Tickets,
  User,
} from "@element-plus/icons-vue";
import AssignToSalesModal from "./AssignToSalesModal.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import TimeShow from "@/components/TimeShow.vue";
import { LeadStatusTypes } from "@/core/types/LeadStatusTypes";
import moment from "moment";
import { AccountRoleTypes } from "@/core/types/AccountInfos";
import TenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";
import UserService from "../../services/UserService";


export default /*#__PURE__*/_defineComponent({
  __name: 'LeadDetailsModal',
  emits: ["update"],
  setup(__props, { expose: __expose, emit: emits }) {

const selectedLead = ref({} as any);
const assignToSalesModalRef = ref<InstanceType<typeof AssignToSalesModal>>();
const isArchived = ref(0);

const size = ref("");
const iconStyle = computed(() => {
  const marginMap = {
    large: "8px",
    default: "6px",
    small: "4px",
  };
  return {
    marginRight: marginMap[size.value] || marginMap.default,
  };
});

const activeNames = ref(["1"]);

const modalRef = ref<any>();
const isLoading = ref(true);

const show = async (_lead) => {
  modalRef.value?.show();
  isLoading.value = true;
  activeNames.value = [];
  selectedLead.value = _lead;
  isArchived.value = _lead.isArchived;
  await getLeadDetails();
  isLoading.value = false;
};

const openAssignSalesModal = () => {
  assignToSalesModalRef.value?.show(selectedLead.value);
};

const openCommentModal = inject(
  TenantGlobalInjectionKeys.OPEN_ADD_COMMENT_MODAL
);

const openAddedCommentModal = () => {
  openCommentModal?.((cmt: string) =>
    UserService.addCommentToLead(selectedLead.value.id, {
      content: cmt,
    }).then(getLeadDetails)
  );
};

const getLeadDetails = async () => {
  try {
    isLoading.value = true;
    selectedLead.value = await UserService.getLeadDetails(
      selectedLead.value.id
    );
  } catch (e) {
    MsgPrompt.error(e);
  } finally {
    isLoading.value = false;
  }
};

const assignSalesSuccess = async () => {
  await getLeadDetails();
  emits("update");
};

const openConfirmModal = inject(TenantGlobalInjectionKeys.OPEN_CONFIRM_MODAL);
const openRemoveConfirmModal = (account) => {
  openConfirmModal?.(
    () =>
      UserService.removeAssignedSalesAccount(
        selectedLead.value.id,
        account.uid
      ).then(() => {
        getLeadDetails();
        emits("update");
      }),
    () => void 0,
    {
      confirmText: `Are you sure to remove this lead from ${account.name} (${account.code})?`,
    }
  );
};

const openArchiveConfirmModal = () => {
  openConfirmModal?.(
    () =>
      UserService.archiveLead(selectedLead.value.id).then(() => {
        getLeadDetails();
        emits("update");
        modalRef.value?.hide();
      }),
    () => void 0,
    {
      confirmText: `Are you sure to archive this lead?`,
    }
  );
};

__expose({
  show,
  hide: () => {
    modalRef.value?.hide();
  },
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _ctx.$t('title.leadDetail'),
    "is-loading": isLoading.value,
    width: 1000,
    "disable-footer": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_descriptions, {
        class: "margin-top",
        title: _ctx.$t('title.personalInfo'),
        column: 3,
        size: size.value,
        border: ""
      }, {
        extra: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
              onClick: openAssignSalesModal,
              class: "btn btn-sm btn-primary me-4 d-flex align-items-center gap-2"
            }, [
              _hoisted_2,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("action.assign")), 1)
            ]),
            _createElementVNode("button", {
              onClick: openAddedCommentModal,
              class: "btn btn-sm btn-info me-4 d-flex align-items-center gap-2"
            }, [
              _hoisted_3,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("action.comment")), 1)
            ]),
            (isArchived.value != 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: openArchiveConfirmModal,
                  class: "btn btn-sm btn-secondary me-4 d-flex align-items-center gap-2"
                }, [
                  _hoisted_4,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("action.archive")), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_icon, {
                  style: _normalizeStyle(iconStyle.value)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(User))
                  ]),
                  _: 1
                }, 8, ["style"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("fields.clientName")), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(selectedLead.value.name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_icon, {
                  style: _normalizeStyle(iconStyle.value)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Message))
                  ]),
                  _: 1
                }, 8, ["style"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("fields.email")), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(selectedLead.value.email), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_icon, {
                  style: _normalizeStyle(iconStyle.value)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Iphone))
                  ]),
                  _: 1
                }, 8, ["style"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("fields.phoneNum")), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(selectedLead.value.phoneNumber), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_icon, {
                  style: _normalizeStyle(iconStyle.value)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Tickets))
                  ]),
                  _: 1
                }, 8, ["style"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("fields.source")), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_tag, {
                type: "warning",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`type.leadSource.${selectedLead.value.sourceType}`)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_icon, {
                  style: _normalizeStyle(iconStyle.value)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Tickets))
                  ]),
                  _: 1
                }, 8, ["style"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("fields.currentStatus")), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_tag, {
                type: 
            {
              [_unref(LeadStatusTypes).UserNotRegistered]: 'info',
              [_unref(LeadStatusTypes).UserRegistered]: 'warning',
              [_unref(LeadStatusTypes).TradeAccountCreated]: 'success',
              [_unref(LeadStatusTypes).AgentAccountCreated]: 'success',
              [_unref(LeadStatusTypes).UserVerificationRejected]: 'danger',
              [_unref(LeadStatusTypes).AccountApplicationRejected]: 'danger',
            }[selectedLead.value.status] ?? ''
          ,
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`type.leadStatus.${selectedLead.value.status}`)), 1)
                ]),
                _: 1
              }, 8, ["type"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_icon, {
                  style: _normalizeStyle(iconStyle.value)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OfficeBuilding))
                  ]),
                  _: 1
                }, 8, ["style"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("fields.createdOn")), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(TimeShow, {
                "date-iso-string": selectedLead.value.createdOn
              }, null, 8, ["date-iso-string"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title", "size"]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_el_collapse, {
          modelValue: activeNames.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeNames).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse_item, { name: "1" }, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("title.assignments")), 1)
              ]),
              default: _withCtx(() => [
                (selectedLead.value.assignedAccounts?.length > 0)
                  ? (_openBlock(), _createBlock(_component_el_timeline, { key: 0 }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedLead.value.assignedAccounts, (acc, index) => {
                          return (_openBlock(), _createBlock(_component_el_timeline_item, {
                            key: index,
                            timestamp: 
                acc.role === _unref(AccountRoleTypes).Sales
                  ? `Sales Code: ${acc.code}`
                  : `IB Group: ${acc.group}`
              
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(acc.name) + " (Uid:" + _toDisplayString(acc.uid) + ")", 1),
                              _createElementVNode("span", {
                                onClick: ($event: any) => (openRemoveConfirmModal(acc)),
                                class: "ms-3 cursor-pointer badge badge-primary"
                              }, _toDisplayString(_ctx.$t("action.remove")), 9, _hoisted_13)
                            ]),
                            _: 2
                          }, 1032, ["timestamp"]))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, "Lead not assigned yet"))
              ]),
              _: 1
            }),
            _createVNode(_component_el_collapse_item, { name: "2" }, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("title.updateHistory")), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_timeline, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedLead.value.updateLogs, (cmt, index) => {
                      return (_openBlock(), _createBlock(_component_el_timeline_item, {
                        key: index,
                        timestamp: _unref(moment)(cmt.createdOn).format('YYYY-MM-DD HH:mm:ss')
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(cmt.content), 1)
                        ]),
                        _: 2
                      }, 1032, ["timestamp"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(AssignToSalesModal, {
        ref_key: "assignToSalesModalRef",
        ref: assignToSalesModalRef,
        onAssignSuccess: assignSalesSuccess
      }, null, 512)
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})